import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  tablehead:{backgroundColor: "lightGreen",
            fontWeight: 'bold'},
  table: {
    minWidth: 650,
  },
  tablerow: {
    "&:hover": {backgroundColor: "lightBlue !important"},
    backgroundColor: "lightGreen"
  },
});


 function handleClick(name,cal)
{
    console.log('Table Row/Column: ', name,cal);
    // this.sendData(row)
}
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Create a ReactJs App with Table Data', 1, 0.0, "False"),
  createData('Create a Dashboard to Display MobileSense Output Report Data', 1, 0.02, "False"),
  createData('Create a Stripe App Interface to Accept Payment for Services Rendered.', 1, 0.02, "False"),
  createData('Access Test Keys for Stripe App and Test Accept Payment for Services Rendered.', 1, 0.02, "False"),
  createData('Access Output Report Data from S3 Bucket. and Send Output Report Via Email to Customer.', 1, 0.02, "False"),

];

export default function DenseTable() {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tablehead} >Job Description</TableCell>
            <TableCell className={classes.tablehead} align="right">Estimated Time (hrs)</TableCell>
            <TableCell className={classes.tablehead} align="right">Bounty Reward ($BCH)</TableCell>
            <TableCell className={classes.tablehead} align="right">Completed</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow className={classes.tablerow} key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell  onClick={() => handleClick(row.name,row.calories)} align="right">{row.calories}</TableCell>
              <TableCell align="right">{row.fat}</TableCell>
              <TableCell align="right">{row.carbs}</TableCell>
              <TableCell align="right">{row.protein}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}